import { Spinner } from 'react-bootstrap';
import { ArrowUpRight } from 'lucide-react';

import { ExternalTool } from '../../../config/external-tools';
import { ListItem, ListItemIcon, ListItemName, ListItemDescription, SsoBadge, VpnBadge, OpeningRow } from '../styles';
import { HoverInfo } from './ModuleRow';

interface ToolRowProps {
  tool: ExternalTool;
  isOpening: boolean;
  onOpen: (tool: ExternalTool) => void;
  onHover?: (info: HoverInfo | null) => void;
}

export const ToolRow = ({ tool, isOpening, onOpen, onHover }: ToolRowProps) => {
  if (isOpening) {
    return (
      <OpeningRow>
        <Spinner animation="border" size="sm" style={{ color: '#7c3aed', width: 16, height: 16 }} />
        Abriendo {tool.name}...
      </OpeningRow>
    );
  }

  return (
    <ListItem
      role="button"
      tabIndex={0}
      onClick={() => onOpen(tool)}
      onKeyDown={(e) => e.key === 'Enter' && onOpen(tool)}
      onMouseEnter={() => onHover?.({ name: tool.name, description: tool.description, kind: 'tool' })}
      onMouseLeave={() => onHover?.(null)}
    >
      <ListItemIcon $color="#0ea5e9">
        <ArrowUpRight size={18} strokeWidth={1.75} />
      </ListItemIcon>
      <ListItemName>{tool.name}</ListItemName>
      <ListItemDescription>{tool.description}</ListItemDescription>
      {tool.sso && <SsoBadge>SSO</SsoBadge>}
      {tool.vpn && <VpnBadge>VPN</VpnBadge>}
    </ListItem>
  );
};
